import React, {useEffect, useState} from "react";
import "./OnlineMedAddress.scss";
import {ChangeDefaultAddress,ChangeDefaultMedAddress, GetBasket, StoreOnlineAddress} from "./OnlineMedAddressService";
import {ConvertToJalali} from "../../Pages/StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import {useHistory} from "react-router-dom";






function OnlineMedAddress({list,merchantId,medId}) {
    //hooks
    const history = useHistory();

    const [address,set_address] = useState([]);
    const [defaultAddress,set_defaultAddress] = useState({});
    const [showModal,setShowModal] = useState(false);

    useEffect(()=>{
        console.log("VVVVVVVVVVVVVVVVV : ",merchantId)
    getAddress()
    },[])

    const getAddress = async () =>{
        const response = await StoreOnlineAddress();
        // console.log("Add : ",response);
        set_address(response.data);
        Basket()
    }

    const AddressClick = () =>{
        setShowModal(true)
    }

    const Basket = async ()=>{
        const response = await GetBasket()
        // console.log("basket : ",response.data)
        if(response.data.address){
            set_defaultAddress(response.data.address)
            await ChangeDefaultMedAddress(response.data.address.uid,merchantId,medId)
        }
    }

    const changeDefaultAddress = async (item)=>{
        set_defaultAddress(item);
        let response = await ChangeDefaultMedAddress(item.uid,merchantId,medId)
        // console.log(response)
    }

    return(
        <div className="address-bar-container">
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                animation={"zoom"} visible={showModal} onClose={()=>setShowModal(false)}>
                <div className="header-title">
                    <span>آدرس تحویل سفارش خود را انتخاب نمایید</span>
                </div>
                <div className="online-address-list">
                    {address.map(item=>{
                        return(
                            <div className="online-address-item"  onClick={()=>{
                                changeDefaultAddress(item)
                            }}>
                                <div className="info-sec">
                                    <span className="name">{item.address.substr(0,2001)}</span>
                                    <span className="address">{item.province.title+"-"+item.city.title}</span>
                                </div>
                                <div className="input-cont">
                                    <input
                                        type="radio" name="address" id="" checked={defaultAddress.uid===item.uid}/>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="add-address-btn-container">
                    <div className="add-address-btn" onClick={()=>{
                        console.log("nn",merchantId)
                        history.push("/online-store-address",{merchantId:merchantId})
                    }}>
                        <span>افزودن آدرس </span>
                        <i className="fa fa-plus"></i>
                    </div>
                </div>
            </Rodal>
            <div className="online-address-bar" onClick={AddressClick}>
                                <i className="fa fa-map-marker"></i>
                                <span>{defaultAddress.address}</span>
                                {/*<i className="fa fa-angle-left"></i>*/}
            </div>
        </div>
    )

}

export {OnlineMedAddress};
